import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Guid } from '@fitscovery/common/types';
import { PartnerMembershipSubscription } from '../models';
import { PartnerMembershipSubscriptionService } from './partner-membership-subscription.service';

import { Environment } from '@fitscovery/common/environments';
import { APP_ENVIRONMENT } from '../environment-injection';

@Injectable()
export class ApiPartnerMembershipSubscriptionService implements PartnerMembershipSubscriptionService {

  constructor(
    @Inject(APP_ENVIRONMENT) private env: Environment,
    private http: HttpClient,
  ) { }

  getPartnerMembershipSubscriptionsById(partnerId: Guid): Observable<PartnerMembershipSubscription[]> {
    const api = `${this.env.azureFunctionsApi.memberships}`;
    return (this.http.get(`${api}/memberships/partners/${partnerId}/subscriptions`) as any).pipe(
      map((membershipSubscriptionData: PartnerMembershipSubscription[]) => {
        return membershipSubscriptionData;
      })
    );
  }

  getPartnerActiveMembershipSubscriptionsById(partnerId: Guid): Observable<PartnerMembershipSubscription[]> {
    const api = `${this.env.azureFunctionsApi.memberships}`;
    return (this.http.get(`${api}/memberships/partners/${partnerId}/active-subscriptions`) as any).pipe(
      map((membershipSubscriptionData: PartnerMembershipSubscription[]) => {
        return membershipSubscriptionData;
      })
    );
  }
}
